const aracSarj = [
  {
    "title": "TommaTech Ticari 60kW DC Elektrikli Araç Şarj İstasyonu",
    "image": "https://cw-enerji.com/images/product/1182_tommatech-ticari-60kw-dc-elektrikli-arac-sarj-istasyonu_0.webp",
    "text": "Yalıtımlı Devrelere Sahip OCPP 1.6 Protokolünü Destekleyen Ticari Faaliyete Uygun Çift Soket Yüksek Hızlı Şarj Ünitesi",
    "variants": []
  },
  {
    "title": "TommaTech Ticari 90kW DC Elektrikli Araç Şarj İstasyonu",
    "image": "https://cw-enerji.com/images/product/1183_tommatech-ticari-90kw-dc-elektrikli-arac-sarj-istasyonu_0.webp",
    "text": "Yalıtımlı Devrelere Sahip OCPP 1.6 Protokolünü Destekleyen Ticari Faaliyete Uygun Çift Soket Yüksek Hızlı Şarj Ünitesi",
    "variants": []
  },
  {
    "title": "TommaTech Ticari 120kW DC Elektrikli Araç Şarj İstasyonu",
    "image": "https://cw-enerji.com/images/product/1184_tommatech-ticari-120kw-dc-elektrikli-arac-sarj-istasyonu_0.webp",
    "text": "Yalıtımlı Devrelere Sahip OCPP 1.6 Protokolünü Destekleyen Ticari Faaliyete Uygun Çift Soket Yüksek Hızlı Şarj Ünitesi",
    "variants": []
  },
  {
    "title": "TommaTech Ticari 180kW DC Elektrikli Araç Şarj İstasyonu",
    "image": "https://cw-enerji.com/images/product/1185_tommatech-ticari-180kw-dc-elektrikli-arac-sarj-istasyonu_0.webp",
    "text": "Yalıtımlı Devrelere Sahip OCPP 1.6 Protokolünü Destekleyen Ticari Faaliyete Uygun Çift Soket Yüksek Hızlı Şarj Ünitesi",
    "variants": []
  },
  {
    "title": "TommaTech Trio EV Charger 22.0kW 6M Kablo&Wifi",
    "image": "https://cw-enerji.com/images/product/1428_tommatech-trio-ev-charger-220kw-6m-kablowifi_0.webp",
    "text": "Farklı şarj modu seçenekleri\nAkıllı, kompakt tasarım\nİç dış mekan uygulamalarında uyumlu\nGeniş çalışma sıcaklığı aralığı",
    "variants": []
  },
  {
    "title": "TommaTech Trio Plus 22kW AC Elektrikli Araç Şarj Cihazı",
    "image": "https://cw-enerji.com/images/product/1478_tommatech-trio-plus-22kw-ac-elektrikli-arac-sarj-cihazi_0.webp",
    "text": "Farklı şarj modu seçenekleri\nAkıllı, kompakt tasarım\nİç dış mekan uygulamalarında uyumlu\nGeniş çalışma sıcaklığı aralığı",
    "variants": []
  },
  {
    "title": "TommaTech 22kW Type2 32A 5m Araç Şarj Kablosu",
    "image": "https://cw-enerji.com/images/product/1480_tommatech-22kw-type2-32a-5m-arac-sarj-kablosu_0.webp",
    "text": "",
    "variants": []
  },
  {
    "title": "TommaTech Trio 22kW Üç Faz/400V AC Elektrikli Araç Şarj Ünitesi Kablosuz",
    "image": "https://cw-enerji.com/images/product/1540_tommatech-trio-22kw-uc-faz400v-ac-elektrikli-arac-sarj-unitesi-kablosuz_0.webp",
    "text": "Farklı şarj modu seçenekleri\nAkıllı, kompakt tasarım\nİç dış mekan uygulamalarında uyumlu\nGeniş çalışma sıcaklığı aralığı",
    "variants": []
  },
  {
    "title": "TommaTech Trio 22kW Üç Faz/400V AC Elektrikli Araç Şarj Ünitesi Kablolu",
    "image": "https://cw-enerji.com/images/product/1541_tommatech-trio-22kw-uc-faz400v-ac-elektrikli-arac-sarj-unitesi-kablolu_0.webp",
    "text": "Farklı şarj modu seçenekleri\nAkıllı, kompakt tasarım\nİç dış mekan uygulamalarında uyumlu\nGeniş çalışma sıcaklığı aralığı",
    "variants": []
  },
  {
    "title": "TommaTech DC 30KW 100A Tek Çıkışlı EVC",
    "image": "https://cw-enerji.com/images/product/1920_tommatech-dc-30kw-100a-tek-cikisli-evc_0.jpg",
    "text": "Yalıtımlı Devrelere Sahip OCPP 1.6 Protokolünü Destekleyen Ticari Faaliyete Uygun Tek Soket Yüksek Hızlı Şarj Ünitesi",
    "variants": []
  },
  {
    "title": "TommaTech DC 40KW 150A Tek Çıkışlı EVC",
    "image": "https://cw-enerji.com/images/product/1927_tommatech-dc-40kw-150a-tek-cikisli-evc_0.jpg",
    "text": "Yalıtımlı Devrelere Sahip OCPP 1.6 Protokolünü Destekleyen Ticari Faaliyete Uygu Tek Soket Yüksek Hızlı Şarj Ünitesi",
    "variants": []
  },
  {
    "title": "TommaTech DC 60KW 200A Tek Çıkışlı EVC",
    "image": "https://cw-enerji.com/images/product/1929_tommatech-dc-60kw-200a-tek-cikisli-evc_0.jpg",
    "text": "Yalıtımlı Devrelere Sahip OCPP 1.6 Protokolünü Destekleyen Ticari Faaliyete Uygun Tek Soket Yüksek Hızlı Şarj Ünitesi",
    "variants": []
  },
  {
    "title": "TommaTech DC 60KW 200A Çift Çıkışlı EVC",
    "image": "https://cw-enerji.com/images/product/1930_tommatech-dc-60kw-200a-cift-cikisli-evc_0.jpg",
    "text": "Yalıtımlı Devrelere Sahip OCPP 1.6 Protokolünü Destekleyen Ticari Faaliyete Uygun Çift Soket Yüksek Hızlı Şarj Ünitesi",
    "variants": []
  },
  {
    "title": "TommaTech DC 80KW 250A Çift Çıkışlı EVC",
    "image": "https://cw-enerji.com/images/product/1931_tommatech-dc-80kw-250a-cift-cikisli-evc_0.jpg",
    "text": "Yalıtımlı Devrelere Sahip OCPP 1.6 Protokolünü Destekleyen Ticari Faaliyete Uygun Çift Soket Yüksek Hızlı Şarj Ünitesi",
    "variants": []
  },
  {
    "title": "TommaTech DC 90KW 300A Tek Çıkışlı EVC",
    "image": "https://cw-enerji.com/images/product/1937_tommatech-dc-90kw-300a-tek-cikisli-evc_0.jpg",
    "text": "Yalıtımlı Devrelere Sahip OCPP 1.6 Protokolünü Destekleyen Ticari Faaliyete Uygun Tek Soket Yüksek Hızlı Şarj Ünitesi",
    "variants": []
  },
  {
    "title": "TommaTech DC 90KW 300A Çift Çıkışlı EVC",
    "image": "https://cw-enerji.com/images/product/1938_tommatech-dc-90kw-300a-cift-cikisli-evc_0.jpg",
    "text": "Yalıtımlı Devrelere Sahip OCPP 1.6 Protokolünü Destekleyen Ticari Faaliyete Uygun Çift Soket Yüksek Hızlı Şarj Ünitesi",
    "variants": []
  },
  {
    "title": "TommaTech DC 120KW 400A Çift Çıkışlı EVC",
    "image": "https://cw-enerji.com/images/product/1939_tommatech-dc-120kw-400a-cift-cikisli-evc_0.jpg",
    "text": "Yalıtımlı Devrelere Sahip OCPP 1.6 Protokolünü Destekleyen Ticari Faaliyete Uygun Çift Soket Yüksek Hızlı Şarj Ünitesi",
    "variants": []
  },
  {
    "title": "TommaTech DC 160KW 500A Çift Çıkışlı EVC",
    "image": "https://cw-enerji.com/images/product/1941_tommatech-dc-160kw-500a-cift-cikisli-evc_0.jpg",
    "text": "Yalıtımlı Devrelere Sahip OCPP 1.6 Protokolünü Destekleyen Ticari Faaliyete Uygun Çift Soket Yüksek Hızlı Şarj Ünitesi",
    "variants": []
  },
  {
    "title": "TommaTech DC 180KW 500A Çift Çıkışlı EVC",
    "image": "https://cw-enerji.com/images/product/1943_tommatech-dc-180kw-500a-cift-cikisli-evc_0.jpg",
    "text": "Yalıtımlı Devrelere Sahip OCPP 1.6 Protokolünü Destekleyen Ticari Faaliyete Uygun Çift Soket Yüksek Hızlı Şarj Ünitesi",
    "variants": []
  },
  {
    "title": "TommaTech DC 240KW 500A Çift Çıkışlı EVC",
    "image": "https://cw-enerji.com/images/product/1944_tommatech-dc-240kw-500a-cift-cikisli-evc_0.jpg",
    "text": "Yalıtımlı Devrelere Sahip OCPP 1.6 Protokolünü Destekleyen Ticari Faaliyete Uygun Çift Soket Yüksek Hızlı Şarj Ünitesi",
    "variants": []
  },
  {
    "title": "TommaTech DC 320KW 600A Çift Çıkışlı EVC",
    "image": "https://cw-enerji.com/images/product/1945_tommatech-dc-320kw-600a-cift-cikisli-evc_0.jpg",
    "text": "Yalıtımlı Devrelere Sahip OCPP 1.6 Protokolünü Destekleyen Ticari Faaliyete Uygun Çift Soket Yüksek Hızlı Şarj Ünitesi",
    "variants": []
  },
  {
    "title": "TommaTech DC 400KW 600A Çift Çıkışlı EVC",
    "image": "https://cw-enerji.com/images/product/1946_tommatech-dc-400kw-600a-cift-cikisli-evc_0.jpg",
    "text": "Yalıtımlı Devrelere Sahip OCPP 1.6 Protokolünü Destekleyen Ticari Faaliyete Uygun Çift Soket Yüksek Hızlı Şarj Ünitesi",
    "variants": []
  },
  {
    "title": "TommaTech Trio 22kW Üç Faz/400V AC Elektrikli Araç Şarj Cihazı",
    "image": "https://cw-enerji.com/images/product/696_tommatech-trio-22kw-uc-faz400v-ac-elektrikli-arac-sarj-cihazi_0.webp",
    "text": "Farklı şarj modu seçenekleri\nAkıllı, kompakt tasarım\nİç dış mekan uygulamalarında uyumlu\nGeniş çalışma sıcaklığı aralığı",
    "variants": []
  }
];

export default aracSarj;
